import { Row, Column, Caption } from 'gatsby-theme-carbon/src/components/Grid';
import { withPrefix } from "gatsby";
import img1 from "../../../../src/visuals/design/L2_visual_2_1_eg.png";
import img2 from "../../../../src/visuals/design/L2_visual_2_2_eg.png";
import img3 from "../../../../src/visuals/design/L2_visual_2_3_eg.png";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  Caption,
  withPrefix,
  img1,
  img2,
  img3,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};